import { GetDocumentListSettingsDocument, GetAnnotationSettingsDocument } from '@sketch/gql-types';

const initializeLocalApolloState = (cache) => {
    // Initialize the DocumentLayout grid setting on cache
    cache.writeQuery({
        query: GetDocumentListSettingsDocument,
        data: {
            __typename: 'RootQueryType',
            documentsLayout: 'GRID',
            showDocumentsInProjects: true,
        },
    });
    // Initialize the Annotation settings on cache
    cache.writeQuery({
        query: GetAnnotationSettingsDocument,
        data: {
            __typename: 'RootQueryType',
            hideAnnotationsDots: false,
        },
    });
};

export { initializeLocalApolloState };
